@if (hasPrice()) {
  <span>{{ price() | currency: 'USD' }}</span>
} @else {
  <span>N/A</span>
}
